import React from "react";
import { CardContent } from "@material-ui/core";
import { CardPageItem } from "../../custom/Page";
import LoadingSpinner from "./LoadingSpinner";
import AbtcMaterialTable from "./TableList";
import { TABLE_LOCALIZATION, TABLE_PAGING } from "./HistoryWithdrawal";

const HistoryWithdrawalTable = ({
  tableRef,
  tableKey,
  data,
  columns,
  onOrderChange,
  showTableOverlayLoading = true,
  pageSize,
  tableOptions,
  actions,
  currentUser,
  overlayBackgroundColor = "#0B0B0B",
}) => {
  const handleOrderChange = React.useCallback(
    (orderByIndex, orderDirection) => {
      if (!onOrderChange) return;

      const column = columns?.[orderByIndex];
      if (!column?.field) return;

      onOrderChange(column.field, orderDirection);
    },
    [columns, onOrderChange],
  );

  return (
    <CardPageItem>
      <CardContent>
        <div style={{ position: "relative" }}>
          <AbtcMaterialTable
            key={tableKey}
            tableRef={tableRef}
            data={data}
            columns={columns}
            options={{
              ...tableOptions,
              ...TABLE_PAGING,
              emptyRowsWhenPaging: false,
              pageSize,
            }}
            user={currentUser}
            actions={actions}
            localization={TABLE_LOCALIZATION}
            onOrderChange={handleOrderChange}
            components={{
              OverlayLoading: () => {
                if (!showTableOverlayLoading) return null;

                return (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: overlayBackgroundColor,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 10,
                    }}
                  >
                    <LoadingSpinner marginTop={0} />
                  </div>
                );
              },
            }}
          />
        </div>
      </CardContent>
    </CardPageItem>
  );
};

export default HistoryWithdrawalTable;
